// request unsuspend
const ListReqUnsuspend = () => import('@/views/request-unsuspend');
const DetailReqUnsuspend = () => import('@/views/request-unsuspend/detail');
export default {
    path: 'request-unsuspend',
    redirect: '/request-unsuspend',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'request-unsuspend',
            component: ListReqUnsuspend,
            meta: {
                link: 'request-unsuspend',
                breadcrumb: [
                    { title: 'Request Unsuspend', active: true },
                ],
                pageTitle: 'Request Unsuspend'
            },
        },
        {
            path: ':id',
            name: 'detailrequnsuspend',
            component: DetailReqUnsuspend,
            meta: {
                link: 'request-unsuspend',
                breadcrumb: [
                    { title: 'Brand Ambassador', url: '/request-unsuspend' },
                    { title: 'View', active: true }
                ],
                pageTitle: 'View Brand Ambassador'
            },
        },
    ]
}